<h1 mat-dialog-title>PROLONGATION DECISION</h1>
<div
  mat-dialog-content
  [formGroup]="form">
  <mat-form-field class="dates">
    <input
      matInput
      value="{{ form.value.prolongationDeadline | date : 'dd.MM.yyyy' : '+0000' }}"
      placeholder="The Prolongation Request asks for"
      disabled />
  </mat-form-field>
  <mat-form-field class="dates"
    ><input
      matInput
      value="{{ form.get('currentDeadlineDate')?.value | date : 'dd.MM.yyyy' : '+0000' }}"
      placeholder="Actual Deadline is"
      disabled />
  </mat-form-field>
  <div class="buttons">
    <mat-button-toggle-group (change)="selectedTab($event.value)">
      <mat-button-toggle value="0"> Grant as requested </mat-button-toggle>
      <mat-button-toggle value="1"> Grant other date </mat-button-toggle>
      <mat-button-toggle value="2"> Reject Prolongation </mat-button-toggle>
    </mat-button-toggle-group>
  </div>
  <div>
    <p>Remark to Coordinator</p>
    <app-editor
      [form]="form"
      controlName="shortRemarkToAssessor" />
  </div>
  @if (showDateField()) {
  <div>
    <mat-form-field appearance="fill">
      <input
        matInput
        formControlName="prolongationOtherDate"
        [matDatepicker]="picker"
        placeholder="Other Deadline" />
      <mat-datepicker-toggle
        matSuffix
        [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker
        #picker
        [disabled]="false"></mat-datepicker>
    </mat-form-field>
  </div>
  }
  <div>
    <button
      mat-raised-button
      (click)="setChoice()">
      OK
    </button>
  </div>
</div>
